<template>
  <div>
    <div id="relen">
      <div>
        <div style="display:inline-block">
          <el-input v-model="para.orderId" placeholder="请输入销售合同号" @change="(value) => {return handleSearch(0, value)}"></el-input>
        </div>
        <el-select v-model="para.processMode" placeholder="处理方式" @change="(value) => {return handleSearch(1, value)}" clearable>
          <el-option
            v-for="n in getprocessMode"
            :key="n.key"
            :label="n.name"
            :value="n.id">
          </el-option>
        </el-select>
        <el-select v-model="para.returnReason" placeholder="退货原因" @change="(value) => {return handleSearch(2, value)}">
          <el-option
            v-for="n in getreturnReason"
            :key="n.key"
            :label="n.name"
            :value="n.id">
          </el-option>
        </el-select>
      </div>
      <div class="comond_btn">
        <el-button  @click="handleSet('add', null)" >补货</el-button>
      </div>
    </div>
    <!-- 列表 -->

      <template>
        <el-table
          :data="list"
          style="width: 100%">

          <el-table-column
            label="销售合同号">
            <template slot-scope="scope">
              <div>{{ scope.row.contractNumber }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="商品名称">
            <template slot-scope="scope">
              <div>{{ scope.row.goodsName }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="型号">
            <template slot-scope="scope">
              <div>{{ scope.row.model }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="采购商">
            <template slot-scope="scope">
              <div>{{ scope.row.companyName }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="补货总数量/kg">
            <template slot-scope="scope">
              <div>{{ scope.row.totalWeight }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="破包处理方式">
            <template slot-scope="scope">
              <div>{{ checkStatus('processMode', scope.row.processMode) }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="退回原因">
            <template slot-scope="scope">
              <div>{{ checkStatus('returnReason', scope.row.returnReason) }}</div>
            </template>
          </el-table-column>

           <el-table-column
            label="退回仓库">
            <template slot-scope="scope">
              <div>{{ checkStatus('returnWarehouse', scope.row.returnWarehouse) }}</div>
            </template>
          </el-table-column>

           <el-table-column
            label="状态">
            <template slot-scope="scope">
              <div>{{ checkStatus('cargoStatus', scope.row.cargoStatus) }}</div>
            </template>
          </el-table-column>
          
          <el-table-column
            width="320"
            label="操作选项">
            <template slot-scope="scope">
              <!-- cargoStatus: '', //  1.待处理,2待发货3.已发货,4已完成 -->
              <!-- processMode: '', //  处理方式1立即补货 2 下一单补货 -->
              <!-- <el-button
                size="mini"
                type="primary"
                @click="handleSet('search', scope.row)">查看</el-button>
              <el-button
                size="mini"
                v-if="scope.row.cargoStatus === 2 || scope.row.cargoStatus === 1"
                @click="handleSet('edit', scope.row)">编辑</el-button> -->
              <el-button
                size="mini"
                type="warning"
                v-if="scope.row.cargoStatus === 1 && scope.row.processMode === 1"
                @click="handleSet(1, scope.row)">处理</el-button>
              <el-button
                size="mini"
                type="warning"
                v-if="scope.row.cargoStatus === 1 && scope.row.processMode === 2"
                @click="handleSet(11, scope.row)">处理</el-button>
              <!-- <el-button
                size="mini"
                type="info"
                v-if="scope.row.cargoStatus === 2 && scope.row.processMode === 1"
                @click="handleSet(2, scope.row)">发货</el-button> -->
              <el-button
                size="mini"
                type="success"
                v-if="scope.row.cargoStatus === 3 && scope.row.processMode === 1"
                @click="handleSet(3, scope.row)">确认收货</el-button>
              <!-- <el-button
                size="mini"
                type="danger"
                v-if="scope.row.cargoStatus === 1"
                @click="handleSet('delete', scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      <div style="text-align:center;">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="(value) => {return handleSearch(5, value)}"
          :current-page="para.pageIndex"
          :total="total">
        </el-pagination>
      </div>
    </template>
    <!-- 弹框 -->
    <el-dialog
        :title="dialogPara.title"
        :visible.sync="dialogPara.isShowDialog"
        width="50%"
        center>
        <!-- 内容 -->
        <el-form :model="form" :rules="dialogPara.rules">
          <!-- 补货 -->
          <div v-if="currentStatus === 'add'">
            <el-form-item label="销售合同" v-if="currentStatus !== 'add'">
              <el-input v-model="form.contractNumber" :disabled="true" v-if="dialogPara.isshow === false"></el-input>
              <div v-if="dialogPara.isshow === true">{{ form.contractNumber }}</div>
            </el-form-item>

            <el-form-item label="销售合同" v-if="currentStatus === 'add'">
              <el-select v-model="form.id" placeholder="请选择" value-key='id' @change="(value) => { return handleChange('contractNumber', value)}">
                <el-option
                  v-for="item in getpendingdamagedList"
                  :key="item.key"
                  :label="item.contractNumber"
                  :value="item">
                </el-option>
              </el-select>
              <div v-if="dialogPara.isshow === true">{{ form.returnReason }}</div>
            </el-form-item>

            <el-form-item label="补货原因">
              <el-select v-model="form.returnReason" placeholder="请选择" @change="(value) => { return handleChange('returnReason', value)}" v-if="dialogPara.isshow === false">
                <el-option
                  v-for="item in getreturnReason"
                  :key="item.key"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <div v-if="dialogPara.isshow === true">{{ form.returnReason }}</div>
            </el-form-item>

            <el-form-item label="退回仓库">
              <el-select v-model="form.returnWarehouse" placeholder="请选择" @change="(value) => { return handleChange('returnWarehouse', value)}" v-if="dialogPara.isshow === false">
                <el-option
                  v-for="item in getreturnWarehouse"
                  :key="item.key"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <div v-if="dialogPara.isshow === true">{{ form.returnWarehouse }}</div>
            </el-form-item>

            <el-form-item label="补货方式">
              <el-select v-model="form.processMode" placeholder="请选择" @change="(value) => { return handleChange('processMode', value)}" v-if="dialogPara.isshow === false">
                <el-option
                  v-for="item in getprocessMode"
                  :key="item.key"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <div v-if="dialogPara.isshow === true">{{ form.processMode }}</div>
            </el-form-item>

            <!-- 问题批号 -->
            <div v-for="(n, index) in form.batchNumberMap" :key="n.key" class="forBox">
              <div>
                <el-form-item
                  :label="'问题批号' + parseInt(index+1)"
                  :prop="'batchNumberMap.' + index + '.batchNumId'"
                >
                  <el-select v-model="form.batchNumberMap[index].batchNumId" placeholder="问题批号" v-if="dialogPara.isshow === false">
                    <el-option
                      v-for="item in batchNumberList"
                      :key="item.key"
                      :label="item.lotNum"
                      :value="item.batchNumId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

            <div>
              <el-form-item
                :label="'数量' + parseInt(index+1)"
                :prop="'batchNumberMap.' + index + '.salesVolume'"
              >
              <el-input v-model="form.batchNumberMap[index].salesVolume" v-if="dialogPara.isshow === false"></el-input>
              </el-form-item>
            </div>
            <div>
              <el-button @click.prevent="handleRemovePara(n)" type="danger">删除</el-button>
            </div>
          </div>
            
          <p style="text-align:right;">
            <el-button type="warning" @click="handleAddPara()">新增问题批号</el-button>
          </p>
        </div>

        <!-- 立即处理 -->
        <div v-if="currentStatus === 1">

          <div class="disflexbtw">
            <el-form-item label="销售合同号">
              <el-input v-model="form.contractNumber" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="商品名称">
              <el-input v-model="form.goodsName" :disabled="true"></el-input>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="型号">
              <el-input v-model="form.model" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="破包总数量">
              <el-input v-model="form.totalWeight" :disabled="true"></el-input>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="客户名称">
              <el-input v-model="form.companyName" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="规格">
              <el-input v-model="form.packWeight" :disabled="true">
                <el-button slot="append">{{ form.goodsSpec }}</el-button>
              </el-input>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="退货原因">
              <div>{{ checkStatus('returnReason', form.returnReason) }}</div>
            </el-form-item>

            <el-form-item label="退回回收">
              <div>{{ checkStatus('returnWarehouse', form.returnWarehouse) }}</div>
            </el-form-item>
          </div>

           <div class="disflexbtw">
             <el-form-item label="*物流公司">
              <el-select v-model="form.logisticsCompanyId" placeholder="请选择"  @change="(value) => { return handelchangecompany(6, value)}">
                <el-option
                  v-for="item in logisticscompanyList"
                  :key="item.key"
                  :label="item.chineseName?item.chineseName:item.englishName"
                  :value="item.id">
                  <span style="float: left">{{ item.chineseName }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
                </el-option>
              </el-select>
            </el-form-item>

             <el-form-item label="*物流费用" >
              <el-input v-model="form.logisticsFees">
                <el-button slot="append"> ￥</el-button>
              </el-input>
            </el-form-item>
          </div>

          <div class="disflexbtw">
             <el-form-item label="*物流联系人">
              <el-select v-model="form.logisticsContactsId" placeholder="请选择">
                <el-option
                  v-for="item in logisticscontacts"
                  :key="item.key"
                  :label="item.name + ' : ' + item.phone"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="*发货时间">
              <el-date-picker
                v-model="form.deliveryTime"
                type="date"
                placeholder="发货时间">
              </el-date-picker>
            </el-form-item>
          </div>

          <div class="disflexbtw">
             <el-form-item label="*收件地址">
              <el-select v-model="form.consigneeAddressId" placeholder="请选择">
                <el-option
                  v-for="item in receivingaddress"
                  :key="item.key"
                  :label="item.address"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="*收件联系人">
              <el-select v-model="form.contactsId" placeholder="请选择">
                <el-option
                  v-for="item in receivingcontacts"
                  :key="item.key"
                  :label="item.name + ':' + item.phone"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="*发货单(PDF)">
              <el-upload
                class="upload-demo"
                :data="qiniu"
                :limit="1"
                action="https://upload.qiniup.com"
                :show-file-list="true"
                :multiple="false"
                :file-list="fileList.dispatchBillUrl"
                :before-upload="(file) => {return handleBeforeUpload(file, 'dispatchBillUrl')}"
                :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'dispatchBillUrl') }"
                :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'dispatchBillUrl') }"
              >
              <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>

            <el-form-item label="*仓库出货情况(excel)">
              <el-upload
                class="upload-demo"
                :data="qiniu"
                :limit="1"
                action="https://upload.qiniup.com"
                :show-file-list="true"
                :multiple="false"
                :file-list="fileList.warehouseExcelUrl"
                :before-upload="(file) => {return handleBeforeUpload(file, 'warehouseExcelUrl')}"
                :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'warehouseExcelUrl') }"
                :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'warehouseExcelUrl') }"
              >
              <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="*周末是否收货" class="disflexbtw">
                <el-radio v-model="form.weekendWork" label= 1 @change="setValue">是</el-radio>
                <el-radio v-model="form.weekendWork" label= 0 @change="setValue">否</el-radio>
            </el-form-item>
          </div>
          <el-form-item label="*库存">
            <div>&nbsp;</div>
            <div v-for="n in batchNumberIds" :key="n.key">
              仓库地址: {{ n.locationName }}
              <div v-for="nn in n.contractGoodsVos" :key="nn.key">
                采购合同号: {{ nn.contractNum }}
                <el-checkbox-group 
                  v-model="replenishBatchNumIds"
                  @change="(value) => { return handleChange('locat', value) }"
                  >
                  <div>
                    <el-checkbox v-for="nnn in nn.batchNumberGoods" :key="nnn.key" :label="nnn.id">{{ '批号:' + nnn.lotNum + ' ' +'余量:' + nnn.allowance }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </div>
          </el-form-item>
        </div>
        <!-- 立即处理结束 -->

        <!-- 下一单处理 -->
        <div v-if="currentStatus === 11">
          <div class="disflexbtw">
            <el-form-item label="销售合同号">
              <el-input v-model="form.contractNumber" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="商品名称">
              <el-input v-model="form.goodsName" :disabled="true"></el-input>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="型号">
              <el-input v-model="form.model" :disabled="true">
              </el-input>
            </el-form-item>

            <el-form-item label="破包总数量">
              <el-input v-model="form.totalWeight" :disabled="true">
                <el-button slot="append">公斤</el-button>
              </el-input>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="客户名称">
              <el-input v-model="form.companyName" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="规格">
              <el-input v-model="form.packWeight" :disabled="true">
                <el-button slot="append">{{ form.goodsSpec }}</el-button>
              </el-input>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="退货原因">
              <div>{{ checkStatus('returnReason', form.returnReason) }}</div>
            </el-form-item>

            <el-form-item label="退回回收">
              <div>{{ checkStatus('returnWarehouse', form.returnWarehouse) }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="下一单的销售合同">
              <el-select v-model="form.orderSupervisorId" placeholder="请选择">
                <el-option
                  v-for="item in orderList"
                  :key="item.key"
                  :label="item.contractNumber"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

           <el-form-item label="库存">
            <div>&nbsp;</div>
            <div v-for="n in batchNumberIds" :key="n.key">
              仓库地址: {{ n.locationName }}
              <div v-for="nn in n.contractGoodsVos" :key="nn.key">
                采购合同号: {{ nn.contractNum }}
                <el-checkbox-group 
                  v-model="replenishBatchNumIds"
                  @change="(value) => { return handleChange('locat', value) }"
                  >
                  <div>
                    <el-checkbox v-for="nnn in nn.batchNumberGoods" :key="nnn.key" :label="nnn.id">{{ '批号:' + nnn.lotNum + ' ' +'余量:' + nnn.allowance }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </div>
          </el-form-item>
        </div>
        <!-- 下一单处理结束 -->

        <!-- 确认收货 -->
        <div v-if="currentStatus === 3">
          <div class="disflexbtw">
            <el-form-item label="销售合同号">
              <el-input v-model="form.contractNumber" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="商品名称">
              <el-input v-model="form.goodsName" :disabled="true"></el-input>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="型号">
              <el-input v-model="form.model" :disabled="true">
              </el-input>
            </el-form-item>

            <el-form-item label="破包总数量">
              <el-input v-model="form.totalWeight" :disabled="true">
                <el-button slot="append">公斤</el-button>
              </el-input>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="客户名称">
              <el-input v-model="form.companyName" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="规格">
              <el-input v-model="form.packWeight" :disabled="true">
                <el-button slot="append">{{ form.goodsSpec }}</el-button>
              </el-input>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="退货原因">
              <div>{{ checkStatus('returnReason', form.returnReason) }}</div>
            </el-form-item>

            <el-form-item label="退回回收">
              <div>{{ checkStatus('returnWarehouse', form.returnWarehouse) }}</div>
            </el-form-item>
          </div>

          <el-collapse  v-model="activeName" hidden>
            <el-collapse-item  name="1">
               <div class="disflexbtw">
                  <el-form-item label="下单联系人" class="disflex">
                  <div>{{ form.placeContact? form.placeContact: '无'}}</div>
                  </el-form-item>
                  <el-form-item label="电话" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.phone: '无' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="微信" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.weChat: '无' }}</div>
                  </el-form-item>
                  <el-form-item label="QQ" class="disflex">
                  <div>{{ form.placeContact? form.placeContact.qq: '无' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="销售单价" class="disflex">
                  <div>{{ form.unitCost + form.currencyName }}</div>
                  </el-form-item>
                  <el-form-item label="下单时间" class="disflex">
                  <div>{{ formatime(form.placeOrderTime) }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="付款方式" class="disflex">
                  <div>{{ paymentType(form.paymentType) }}</div>
                  </el-form-item>
                  <el-form-item label="销售数量(净重)" class="disflex">
                  <div>{{ form.salesQuantity + '公斤' }}</div>
                  </el-form-item>
              </div>

              <div class="disflexbtw">
                  <el-form-item label="销售合同" class="disflex">
                  <el-button type="primary" size="mini" @click="downloadpdf(form.salesContractUrl)" >预览下载</el-button>
                  </el-form-item>
                  <el-form-item label="销售总价" class="disflex">
                  <div>{{ form.totalPrices + form.currencyName }}</div>
                  </el-form-item>
              </div>

              <div>
                <el-form-item label="销售数量(毛重)" class="disflex">
                  <div>{{ form.roughWeight }}</div>
                </el-form-item>
              </div>

              <div  v-for="n in form.orderBatchVos" :key="n.key">
                <div>
                    <el-form-item label="仓库地址" class="disflex">
                      <div>{{ n.locationName }}</div>
                    </el-form-item>
                </div>

                <div  v-for="nn in n.batchVos" :key="nn.key">
                  <div v-for="nnn in nn.orderDetailsDtos" :key="nnn.key"  class="disflexbtw">
                    <el-form-item label="批号" class="disflex">
                      <div>{{ nnn.lotNum }}</div>
                    </el-form-item>
                    <el-form-item label="数量" class="disflex">
                        <div>{{ nnn.salesVolume }}</div>
                    </el-form-item>
                  </div>
                </div>
              </div>

            </el-collapse-item>
          </el-collapse>

          <div class="disflexbtw">
             <el-form-item label="物流公司">
              <div>{{ logisticsVo.logisticsCompanyName }}</div>
            </el-form-item>

            <el-form-item label="发货时间">
              <div>{{ formatime(logisticsVo.deliveryTime) }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="物流联系人">
              <div> {{ logisticsVo.logisticsContactName }} : {{ logisticsVo.logisticsContactPhone }}</div>
            </el-form-item>

            <el-form-item label="物流费用">
              <div> {{ logisticsVo.logisticsFees }}￥</div>
            </el-form-item>
            
          </div>

          <div class="disflexbtw">
             <el-form-item label="收件地址">
              <div> {{ logisticsVo.address  }}</div>
            </el-form-item>

            <el-form-item label="收件联系人">
              <div> {{ logisticsVo.contactName }} : {{  logisticsVo.contactPhone }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="发货单">
              <el-button type="primary" size="mini" @click="downloadpdf(logisticsVo.dispathcBillUrl)" >预览下载</el-button>
            </el-form-item>

             <el-form-item label="仓库出货情况(excel)">
              <el-button type="primary" size="mini" @click="downloadpdf(logisticsVo.warehouseExcelUrl)" >预览下载</el-button>
            </el-form-item>
          </div>

          <div class="disflexbtw" v-for=" n in form.supplyBatcheNumbeVos" :key="n.key">
            <el-form-item label="补货批号">
              {{ n.batchNumId }}
            </el-form-item>
            <el-form-item label="补货数量">
              {{ n.supplyQuantity }}公斤
            </el-form-item>
          </div>

          <div>
            <el-form-item label="周六、周日是否出货" class="disflex">
               <div> {{ form.weekendWork === '1'? '是': '否'  }}</div>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="*签收日期">
              <el-date-picker
                v-model="form.signTime"
                type="date"
                placeholder="签收日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="*签收单">
              <el-upload
                class="upload-demo"
                :data="qiniu"
                :limit="1"
                action="https://upload.qiniup.com"
                :show-file-list="true"
                :multiple="false"
                :file-list="fileList.receiptFormUrl"
                :before-upload="(file) => {return handleBeforeUpload(file, 'receiptFormUrl')}"
                :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'receiptFormUrl') }"
                :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'receiptFormUrl') }"
              >
              <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </div>

          <div class="disflexbtw">
            <el-form-item label="*客户实收" class="dbgroup disflex" >
              <el-input v-model="form.realQuantity" @change="(value) => { return handleChange('realQuantity', value) }">
                <el-button slot="append">公斤</el-button>
              </el-input>
            </el-form-item>
          </div>

          <div v-if="ishowreplenishment === true">
            <el-form-item label="处理方式" class="disflex">
               <el-radio v-model="form.isReplenishment" label="1" @change="(value) => { return handleChange('isReplenishment', value) }">补货</el-radio>
               <el-radio v-model="form.isReplenishment" label="0" @change="(value) => { return handleChange('isReplenishment', value) }">不补货</el-radio>
            </el-form-item>

              <el-form-item label="重新上传的销售合同PDF文件" v-if="ishowreplenishment2 == 0">
                <el-upload
                  class="upload-demo"
                  :data="qiniu"
                  :limit="1"
                  action="https://upload.qiniup.com"
                  :show-file-list="true"
                  :multiple="false"
                  :file-list="fileList.salesContractUrl"
                  :before-upload="(file) => {return handleBeforeUpload(file, 'salesContractUrl')}"
                  :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'salesContractUrl') }"
                  :on-remove="(file, fileList) => { return handleOnRemove(file, fileList, 'salesContractUrl') }"
                >
                <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            </el-form-item>
          </div>
        </div>
        <!-- 确认收货结束 -->

      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogPara.isShowDialog = false">取 消</el-button>
          <el-button type="primary" @click="handleSucess">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//  补货列表, 需要补货的销售订单关联批号, 待补货销售合同号列表, 
//  补货, 立即补货, 订单详情, 
//  物流公司, 物流联系人, 收件地址, 
//  七牛上传, 库存, 七牛下载
//  补货详情, 补货确认收货
//  订单列表
import { damagedquerydamaged, orderqueryBatchNumberById, damagedpendingdamagedList, 
damagedreplenishdamaged, damagedshipments, orderqueryOrderDetails, 
findAll, queryByCompanyId, addressfindByCompanyId, 
qiniuupload, stockgoods, qiniugetDown,
damagedqueryDamagedDetails, damagednotarizeCargo,
orderqueryList } from '../../api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import utils from '../../../public/utils'
export default {
  data () {
    return {
      qiniu: { //  七牛上传
        token: '',
        key: '',
        uploadUrl: '', //  上传地址前缀
      },
      fileList: { //  文件存储
        dispatchBillUrl: [], //  发货单
        warehouseExcelUrl: [], //  仓库出货情况url
        receiptFormUrl: [], //  签收单
        salesContractUrl: [], //    重新上传的销售合同
      },
      para: { //  查询条件
        orderId: '', //  订单编号
        processMode: '', //  处理方式1立即补货 2 下一单补货
        returnReason: '', //  退货原因1破包2不合格
        pageIndex: 1, //  页码
        pageSize: 10 //  每页数量
      },
      list: [ //  列表数据
        {
          orderId: 61, //  订单id
          contractNumber: '20190401', //  销售合同号
          returnReason: 2, //  退货原因1破包2不合格
          batchNumberMap: [ //  需要补货的销售订单关联批号
            {
              id: 1,
              orderId: 61, //  订单id
              batchNumId: 7, //  批号id
              salesVolume: 100, //  批号销售数量
            },
          ],
          returnWarehouse: 'T', //  T退回仓库,F不退回仓库
          processMode: 1, //  处理方式1立即补货 2 下一单补货
          cargoStatus: 3 //   1.待处理,2待发货3.已发货,4已完成
        }
      ],
      dialogPara: { //  弹出框配置
        isshow: false, //  默认不显示参数
        isShowDialog: false, //  默认关闭弹出框
        title: '', //  弹出框标题
        rules: null, //  规则
      },
      total: 0, //  列表总数
      form: {
        replenishBatchNumIds: [],
      },
      currentStatus: '', //  当前操作状态
      activeName: '1', //  折叠面板
      ishowreplenishment: false, //  是否显示处理方式
      ishowreplenishment2: null, //  是够显示上传PDF
      batchNumberList: [], //  批号列表
      getpendingdamagedList: [], //  待补货合同号列表
      logisticscompanyList: [], //  物流公司
      logisticscontacts: [], //  物流联系人
      receivingaddress: [], // 收件地址
      receivingcontacts: [], // 收件联系人
      batchNumberIds: [], //  库存列表
      replenishBatchNumIds: [], //  选中的补货库存
      orderList: [], //  订单列表
      logisticsVo: {}
    }
  },
  computed: { //  调用退货原因跟处理方式列表数据
    ...mapGetters([
      'getprocessMode', //  处理方式
      'getreturnReason', //  补货退货原因
      'getreturnWarehouse', //  是否退回仓库
    ])
  },
  mounted () {
    this.getdamagedquerydamaged() //  补货列表
    this.getToken() //  获取qiniu的token
  },
  methods: {
    getToken () { //  获取qiniu的token
      let para = new URLSearchParams()
      para.append('bucket', 'crm-sea-transportation')
      qiniuupload(para).then((res) => {
        console.log(res.data)
        this.qiniu.token = res.data.uploadToken
        this.qiniu.uploadUrl = res.data.url
      })
    },
    downloadpdf (w) { // 下载
      console.log(w)
      let para = new URLSearchParams()
      para.append('baseUrl', w)
      qiniugetDown(para).then(data => {
        console.log(data.data)
        window.open(data.data)
      })
    },
    paymentType (num) {
      switch (num) {
        case 1:
          return '货到付款'
        case 2:
          return '款到发货'
        case 3:
          return '预售部分发货'
      }
    },
    handleBeforeUpload (file, type) { //  上传之前
      this.qiniu.key = ``+ type +`${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess (response, file, fileList, type) { //  上传成功之后
      this.form[type] =  this.qiniu.uploadUrl + response.key
    
      this.fileList[type].push({ //  显示文件
        name: response.key,
        url: this.qiniu.uploadUrl + response.key
      })
      console.log(type)
    },
    handleOnRemove (file, fileList, type) { //  删除
      this.fileList[type] = []
      console.log(file, fileList)
    },
    handleSearch (type, val) { //  0.合同号, 1.处理方式, 2.退货原因, 5.分页
      console.log(type, val)
      switch(type) {
        case 5:
          this.para.pageIndex = val
          break
      }
      this.getdamagedquerydamaged()
    },
    handleChange (type, val) { // //  下拉值改变执行的操作 'contractNumber'.销售合同号
      console.log(type, val)
      switch (type) {
        case 'contractNumber':
          this.getorderqueryBatchNumberById(val.orderId) //  调用待补货合同号列表
          break
        case 'locat': //  采购合同号
          console.log(val)
          break
        case 'realQuantity': //  计算价格
          if (this.form.realQuantity < this.form.totalWeight) {
            this.ishowreplenishment = true
          } else {
            this.ishowreplenishment = false
            this.form.isReplenishment = ''
          }
          break
        case 'isReplenishment':
          this.fileList.salesContractUrl = []
          this.ishowreplenishment2 = val
          break
      }
    },
    handleSet (type, val) { // add.新增, search.查看详情, edit.编辑, delete.删除, 1.处理, 2.发货, 3.确认收货
      console.log(type, val)
      
      // this.form = val
      this.currentStatus = type //  设置当前操作状态
      switch (type) {
        case 'search':
          break
        case 'add':
          this.dialogPara.title = '补货'
          this.dialogPara.isShowDialog = true
          this.form = {}
          this.form = { //  列表数据
            orderId: '', //  订单id
            contractNumber: '', //  销售合同号
            returnReason: '', //  退货原因1破包2不合格
            batchNumberMap: [ //  需要补货的销售订单关联批号
              {
                id: '',
                orderId: '', //  订单id
                batchNumId: '', //  批号id
                salesVolume: '', //  批号销售数量
              },
            ],
            returnWarehouse: '', //  T退回仓库,F不退回仓库
            processMode: '', //  处理方式1立即补货 2 下一单补货
            cargoStatus: '' //   1.待处理,2待发货3.已发货,4已完成
          }
          this.getdamagedpendingdamagedList() //  查询待补货合同号列表
          break
        case 'edit':
          this.dialogPara.isShowDialog = true
          this.dialogPara.title = '编辑'
          this.getorderqueryBatchNumberById(val.orderId) //  需要补货的销售订单关联批号
          break
        case 1: //  立即处理
          this.dialogPara.isShowDialog = true
          this.dialogPara.title = '立即补货处理'
          this.fileList = { //  文件存储
            dispatchBillUrl: [], //  发货单
            warehouseExcelUrl: [], //  仓库出货情况url
          }
          this.getdamagedqueryDamagedDetails(val.id) //  调用订单详情
          break
        case 11: //  下一单处理
          this.dialogPara.isShowDialog = true
          this.dialogPara.title = '下一单补货处理'
          this.getdamagedqueryDamagedDetails(val.id) //  调用订单详情
          this.getorderqueryList(val.companyId) //  查询状态为待发货的订单
          break
        case 3: //  完成收货
          this.dialogPara.title = '确认收货'
          console.log(val)
          this.fileList = { //  文件存储
            receiptFormUrl: [], //  签收单
            salesContractUrl: [], //    重新上传的销售合同
          },
          this.dialogPara.isShowDialog = true
          this.getdamagedqueryDamagedDetails(val.id) //  调用订单详情
      }
    },
    handleSucess () { //  保存
      // this.dialogPara.isShowDialog = false
      // add.新增, search.查看详情, edit.编辑, delete.删除, 1.处理, 2.发货, 3.确认收货
      let f = this.form
      let para
      switch (this.currentStatus) { //  根据当前操作状态执行对应操作
        case 'add':
          this.setdamagedreplenishdamaged() //  补货
          break
        case 'search':
          this.dialogPara.isShowDialog = false
          break
        case 'edit':
          break
        case 'delete':
          break
        case 1: //  处理
          console.log(this.form, '立即补货')
          if( !f.weekendWork || !this.replenishBatchNumIds || !f.logisticsCompanyId ||
          !f.logisticsContactsId || !f.deliveryTime || !f.consigneeAddressId || 
          !f.logisticsFees || !f.dispatchBillUrl || !f.warehouseExcelUrl || 
          !f.contactsId) {
          // !f.contactsId || !f.orderSupervisorId) {
          return this.$message({
              message: '参数不完整！星号必填！',
              type: 'error'
            })
          }
          this.form.deliveryTime = this.formatime(this.form.deliveryTime)
          para = new URLSearchParams(this.form)
          para.append('replenishBatchNumIds', this.replenishBatchNumIds)
          damagedshipments(para).then(data => {
            this.handletips(data)
          })
          break
        case 11: //  处理
          console.log(this.form, '下一单补货')
          para = new URLSearchParams(this.form)
          para.append('replenishBatchNumIds', this.replenishBatchNumIds)
          damagedshipments(para).then(data => {
            this.handletips(data)
          })
          break
        case 2: //  发货
          break
        case 3: //  确认收货
          console.log(this.form, '确认收货')
          if( !f.signTime || !f.realQuantity || !f.receiptFormUrl) {
          return this.$message({
              message: '参数不完整！星号必填！',
              type: 'error'
            })
          }
          this.form.signTime = this.formatime(this.form.signTime) //  签到时间
          para = new URLSearchParams(this.form)
          damagednotarizeCargo(para).then(data => {
            this.handletips(data)
          })
          break
      }
    },
    checkStatus (type, val) {  //  状态
      let res
      switch (type) { //  返回当前的补货状态 1.待处理,2代发货3.已发货,4已完成
        case 'cargoStatus':
          res = utils.cargoStatus(val)
          return res
        case 'processMode': //  处理方式1立即补货 2 下一单补货
          res = utils.processMode(val)
          return res
        case 'returnReason': //  处理方式1立即补货 2 下一单补货
          res = utils.returnReason(val)
          return res
        case 'returnWarehouse': //  T退回仓库,F不退回仓库
          res = utils.returnWarehouse(val)
          return res
      }
    },
    getdamagedquerydamaged () { // 查询补货列表
      let para = new URLSearchParams(this.para)
      damagedquerydamaged(para).then(data => {
        console.log(data)
        this.list = data.data.rows
        this.total = data.data.total
      })
    },
    getorderqueryList (id) { //  查询状态为待发货的订单
      console.log('查询状态为待发货的订单')
      let ps = {
        orderStatus: 4,
        pageIndex: 1,
        pageSize: 1000,
      }
      if (id) {
        ps.companyId = id
      }
      let para = new URLSearchParams(ps)
      orderqueryList(para).then(data => {
        console.log(data)
        this.orderList = data.data.rows
      })
    },
    getorderqueryBatchNumberById (id) { //  需要补货的销售订单关联批号
      console.log(id)
      let para = new URLSearchParams()
      para.append('id', id)
      orderqueryBatchNumberById(para).then(data => {
        console.log(data)
        this.batchNumberList = data.data
      })
    },
    getdamagedpendingdamagedList () { //  待补货合同号列表
      let para = new URLSearchParams()
      damagedpendingdamagedList(para).then(data => {
        console.log(data)
        this.getpendingdamagedList = data.data
      })
    },
    getorderqueryOrderDetails (val) { //  查询订单详情
      console.log(val)
      let para = new URLSearchParams()
      para.append('id', val)
      orderqueryOrderDetails(para).then(data => {
        console.log(data)
        this.form = data.data
        this.getaddressfindByCompanyId(this.form.companyId) //  调用收件地址
        this.getstockgoods(this.form.goodsId)
        this.handelchangecompany(6)
        this.getqueryByCompanyId('receiv', this.form.companyId) //  查询收件联系人
      })
    },
    getdamagedqueryDamagedDetails (val) { //  补货详情
      console.log(val)
      let para = new URLSearchParams()
      para.append('id', val)
      damagedqueryDamagedDetails(para).then(data => {
        console.log(data)
        this.form = data.data
        if(this.form.logisticsVo) {
          this.logisticsVo = this.form.logisticsVo
        }
        if (this.currentStatus === 3) { //  确认收货状态下清空客户实收
          this.form.realQuantity = null
        }
        this.getaddressfindByCompanyId(this.form.companyId) //  调用收件地址
        this.getstockgoods(this.form.goodsId)
        this.handelchangecompany(6) //  查询物流公司
        this.getqueryByCompanyId('receiv', this.form.companyId) //  查询收件联系人
      })
    },
    getqueryByCompanyId (type, val) { //  根据公司id查询联系人列表
      console.log(val)
      let para = {
        id: val
      }
      queryByCompanyId(para).then(data => {
        console.log(data)
        switch(type) {
          case 6:
            this.logisticscontacts = []
            this.logisticscontacts = data.data.data //  物流联系人
            break
          case 'receiv':
            this.receivingcontacts = [] //  收件联系人
            this.receivingcontacts = data.data.data
            break
        }
      })
    },
    getaddressfindByCompanyId (row) { //  收件地址
      console.log(row)
      let para = {
        companyId: row
      }
      addressfindByCompanyId(para).then(data => {
        console.log(data)
        this.receivingaddress = data.data.data //  收件地址
      })
    },
    getstockgoods (val) { //  查询余量
      let para = new URLSearchParams()
      para.append('goodsId', val)
      stockgoods(para).then(data => {
        console.log(data)
        this.batchNumberIds = data.data
      })
    },
    setdamagedreplenishdamaged () { // 补货 'add'
      let para = new URLSearchParams()
      para.append('id', this.form.id.id)
      para.append('returnReason', this.form.returnReason)
      para.append('returnWarehouse', this.form.returnWarehouse)
      para.append('processMode', this.form.processMode)
      let a = {}
      this.form.batchNumberMap.forEach(item =>{
        console.log(item)
        item.batchNumId = parseInt(item.batchNumId)
        a[item.batchNumId] = item.salesVolume
      })
      // para.append('orderSupervisorId', this.form.orderSupervisorId) //  如果下一单补货需要下一单的id
      para.append('batchNumberMap', JSON.stringify(a) )
      console.log(para)
      damagedreplenishdamaged(para).then(data => {
        console.log(data)
        this.handletips(data)
      })
    },
    setValue () { //  设置值
      console.log(this.form.weekendWork)
    },
    handleRemovePara (item) { //  删除参数
      let dom = this.form.batchNumberMap
      if (dom.length <= 1) {
        this.$message.error('至少一个参数')
      } else {
        var index = dom.indexOf(item)
        if (index !== -1) {
          dom.splice(index, 1)
        }
      }
    },
    handleAddPara () { //  新增参数
      this.form.batchNumberMap.push(
        {
          batchNumId: '', //  批号id
          salesVolume: '', //  批号销售数量
        },
      )
    },
    handletips (data) { //  操作成功或者失败的回调
      if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getdamagedquerydamaged() //  查询补货列表
          this.dialogPara.isShowDialog = false //  关闭弹出框
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
    },
    handelchangecompany (type, val) { //  公司列表
      console.log(type, val)
      let para = {
        'status': 1,
        'typeId': type
      }
      findAll(para).then(data => {
        console.log(data)
        this.logisticscompanyList = data.data.data //  物流公司
      })
      if (val) {
        this.getqueryByCompanyId(type, val)
      }
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
  }
}
</script>

<style lang="stylus" scoped>
#relen
  display flex
  justify-content space-between
  .comond_btn
    display flex
    justify-content flex-end
    margin-bottom 30px
    button
      background-color #0a3d5f
      color #fff
.el-form-item
  display flex
.forBox {
  display flex
}
.disflexbtw {
  display flex
  justify-content space-between
}
</style>

